export const uiSpacing = {
    xxs: 4,
    xs: 6,
    sm: 8,
    md: 12,
    lg: 16,
    xl: 20
} as const

export const uiRadius = {
    xs: 4,
    sm: 6,
    md: 8,
    lg: 8,
    pill: 999
} as const

export const uiPalette = {
    brand: "#905DFF",
    violet: "#905DFF",
    indigo: "#6D5DF8",
    teal: "#14B8A6",
    sky: "#0EA5E9",
    cyan: "#06B6D4",
    green: "#22C55E",
    amber: "#F59E0B",
    red: "#EF4444",
    blue: "#2563EB",
    slate: "#64748B",
    star: "#FAAD14"
} as const

export const uiAlpha = {
    tint: "14",
    avatar: "22",
    softAccent: "1F"
} as const

/** Low-to-high numeric intensity only; not order status or SLA severity. */
export const uiHeatmapPalette = [uiPalette.blue, uiPalette.cyan, uiPalette.green, "#FACC15", "#F97316"] as const
